(function() {
  function hideBtn(btn) { btn.classList.add('is-hidden'); }
  function showBtn(btn) { btn.classList.remove('is-hidden'); }

  // Click to unmute
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.product-video-unmute');
    if (!btn) return;
    const id = btn.getAttribute('data-for');
    const video = id && document.getElementById(id);
    if (!video) return;

    try {
      video.muted = false;
      video.controls = true; // give user control once unmuted
      const p = video.play && video.play();
      if (p && typeof p.then === 'function') {
        p.finally(() => hideBtn(btn));
      } else {
        hideBtn(btn);
      }
    } catch (err) {
      // If play fails (e.g., autoplay policies), still hide button after unmuting
      hideBtn(btn);
    }
  });

  // Keep button visibility in sync if user toggles mute via controls
  function syncButtonsFor(video) {
    const wrapper = video.closest('.product__video-wrapper');
    if (!wrapper) return;
    const btn = wrapper.querySelector('.product-video-unmute[data-for="' + video.id + '"]');
    if (!btn) return;
    if (video.muted) showBtn(btn); else hideBtn(btn);
  }

  // Initialize on DOM ready
  function init() {
    document.querySelectorAll('.product__video[id]').forEach(function(video) {
      video.addEventListener('volumechange', function() { syncButtonsFor(video); });
      // Initial state
      syncButtonsFor(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();